import { apiClient } from '@shared/api';
import type { ApiResponse } from '@shared/types';
import type { CreateUserDto, UpdateUserDto, NetSuiteEmployeeDto, UserDto } from '../types';

class UserService {
  async getAllUsers(): Promise<UserDto[]> {
    const { data } = await apiClient.get<ApiResponse<UserDto[]>>(
      '/usermanagement'
    );

    if (data.success && data.data) {
      return data.data;
    }

    throw new Error(data.message || 'Failed to fetch users');
  }

  async getUserById(id: number): Promise<UserDto> {
    const { data } = await apiClient.get<ApiResponse<UserDto>>(
      `/usermanagement/${id}`
    );

    if (data.success && data.data) {
      return data.data;
    }

    throw new Error(data.message || 'Failed to fetch user');
  }

  async createUser(userData: CreateUserDto) : Promise<UserDto>{
    const { data } = await apiClient.post<ApiResponse<UserDto>>(
      '/usermanagement',
      userData
    );

    if (data.success && data.data) {
      return data.data;
    }

    throw new Error(data.message || 'Failed to create user');
  }
  async updateUser(id: number, userData: UpdateUserDto): Promise<UserDto> {
    const { data } = await apiClient.put<ApiResponse<UserDto>>(
      `/usermanagement/${id}`,
      userData
    );

    if (data.success && data.data) {
      return data.data;
    }

    throw new Error(data.message || 'Failed to update user');
  }

  async changePassword(userId: number, newPassword: string, confirmNewPassword: string): Promise<void> {
    const { data } = await apiClient.post<ApiResponse<object>>(
      `/usermanagement/${userId}/reset-password`,
      { newPassword, confirmNewPassword }
    );

    if (!data.success) {
      throw new Error(data.message || 'Failed to change password');
    }
  }

  async searchNetSuiteEmployees(search: string): Promise<NetSuiteEmployeeDto[]> {
    const { data } = await apiClient.get<ApiResponse<NetSuiteEmployeeDto[]>>(
      '/usermanagement/netsuite-employees',
      { params: { search } }
    );

    if (data.success && data.data) {
      return data.data;
    }

    throw new Error(data.message || 'Failed to search employees');
  }
}

export const userService = new UserService();
